import { render, staticRenderFns } from "./ModalAddAudioHypnosis.vue?vue&type=template&id=770e33af&scoped=true&"
import script from "./ModalAddAudioHypnosis.vue?vue&type=script&lang=js&"
export * from "./ModalAddAudioHypnosis.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAudioHypnosis.vue?vue&type=style&index=0&id=770e33af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e33af",
  null
  
)

export default component.exports